import { APPLY_COUPON } from "../../../../../constants";
import { apiSlice } from "./apiSlice";

export const couponApiSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    applyCoupon: builder.mutation({
      query: ({ data, token }) => ({
        url: APPLY_COUPON,
        method: "POST",
        body: data, // expects { code, amount }
        headers: {
            Authorization: token ? `Bearer ${token}` : '', 
        },
      }),
    }),
  }),
});

export const { useApplyCouponMutation } = couponApiSlice;
